import { civicApiKey } from "../../config";
import { ICookiesJar } from "./localStorage";

const config = {
  apiKey: civicApiKey,
  product: "PRO_MULTISITE",
  optionalCookies: [
    {
      name: "analytics",
      label: "Analytical Cookies",
      description:
        "Analytical cookies help us to impove our site by collecting and reporting information on its usage.",
      cookies: ["_ga", "_ga_*"],
      lawfulBasis: "legitimate interest",
      onAccept: function () {
        //@ts-expect-error
        window.dataLayer?.push("consent", "update", {
          analytics_storage: "granted",
        });
      },
      onRevoke: function () {
        //@ts-expect-error
        window.dataLayer?.push("consent", "update", {
          analytics_storage: "denied",
        });
      },
    },
  ],
  initialState: "open",
  text: {
    title:
      "Welcome to Eyeware Lite. Before we start, this site uses cookies...",
    intro:
      "Some of these cookies are essential, while others help us to improve your experience by providing insights into how the site is being used. This site does NOT track user data which could be used for advertising or third party data brokers.",
    rejectSettings: "Reject all non essential cookies",
    acceptSettings: "Accept Cookies",
  },
  statement: {
    description:
      "For more detailed information on the cookies we use, please check our",
    name: "Privacy Policy",
    url: "https://www.rnib.org.uk/privacy-policy/",
    updated: "04/10/2021",
  },
  layout: "popup",
  closeStyle: "icon",
  necessaryCookies: ["rnibTCsConsent", "rnibCurrentState"],
  notifyDismissControl: false,
  notifyDismissButton: false,
  branding: {
    fontSize: "1.7vh",
    fontSizeTitle: "1em",
    fontSizeHeaders: "1em",
    backgroundColor: "black",
    acceptBackground: "var(--rnib-pink)",
    rejectBackground: "#464646",
    toggleBackground: "#464646",
    toggleColor: "var(--rnib-pink)",
    acceptText: "white",
    rejectText: "white",
    removeAbout: true,
    removeIcon: true,
  },
  onLoad: () => console.log("🍪 Cookies module loaded"),
};

export const cookiesInit = (): ICookiesJar | undefined => {
  if (typeof CookieControl === undefined) return undefined;

  CookieControl.load(config);

  return {
    setItem(key, value) {
      CookieControl.saveCookie(key, value, 90);
    },
    getItem(key) {
      return CookieControl.getCookie(key) || null;
    },
  };
};
